import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useT } from "@/lib/LanguageContext";
import { SOCIAL_PLATFORMS } from "@/lib/siteLinks";
import { SOCIAL_ICONS } from "@/components/site/socialIcons";

/**
 * The practice's social profiles, published in the footer of all six site templates.
 *
 * One row per network, all optional: the footer renders a link only for the non-empty ones,
 * so an unused network costs nothing. The platform list and the storage keys are the SAME
 * constant the footers read (lib/siteLinks.js `SOCIAL_PLATFORMS`), which is why adding a
 * network is one edit and not seven.
 *
 * Network names are proper nouns, so they are not routed through the locale layer; the
 * example URLs are URLs, not copy.
 */
export default function SocialLinksCard({ branding, setBranding }) {
  const t = useT("admin");
  return (
    <div className="bg-white rounded-2xl border border-eh-border-soft p-6" data-testid="branding-social">
      <h2 className="font-display text-xl mb-1">{t("brand.social")}</h2>
      <p className="text-xs text-eh-muted mb-4">{t("brand.socialHint")}</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {SOCIAL_PLATFORMS.map(({ key, field, label }) => {
          const Icon = SOCIAL_ICONS[key];
          return (
            <div key={key}>
              <Label className="text-xs flex items-center gap-1.5">
                <Icon className="w-3.5 h-3.5 text-eh-muted" /> {label}
              </Label>
              <Input
                value={branding[field] || ""}
                onChange={(e) => setBranding({ ...branding, [field]: e.target.value })}
                data-testid={`branding-${field}`}
                placeholder={`https://${key}.com/…`}
                className="mt-1.5 text-xs"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
